import Vue from 'vue'
import gitinfo from './git.js'
const release = gitinfo.abbreviated_commit;

import App from "./App.vue";
import {
    store
} from "./Store"
import {
    AmplifyEventBus
} from 'aws-amplify-vue';
Vue.prototype.$eventBus = AmplifyEventBus;
import router from "./router";
import introJs from 'intro.js/intro.js';
import "./registerServiceWorker";
import selectable from 'vue-selectable';
//plugins
import UIKit from './plugins/ui-kit';
import Amplify, * as AmplifyModules from 'aws-amplify';
import {
    AmplifyPlugin
} from 'aws-amplify-vue';
import aws_exports from './aws-exports';
import VModal from 'vue-js-modal';
import VueForm from 'vue-form';
import {
    VueSpinners
} from '@saeris/vue-spinners'
import {
    Auth
} from 'aws-amplify';
Vue.prototype.$auth = Auth
import apolloProvider from "@/appsync";
import Multiselect from 'vue-multiselect'
import {
    Progress
} from 'element-ui'
import {
    VueContext
} from 'vue-context';
import LZString from 'lz-string'
import VTooltip from 'v-tooltip'
import SideBar from './components/SidebarPlugin';
Vue.use(SideBar)
import './assets/sass/dashboard.scss';
var juice = require('juice/client')
window.juice = juice
Vue.component('multiselect', Multiselect)
Vue.component('vue-context', VueContext)
Vue.directive('selectable', selectable);

Amplify.configure(aws_exports);
Vue.use(Progress)
Vue.use(UIKit)
Vue.use(VueForm)
Vue.use(VTooltip, {
    autoHide: true,
    defaultHideOnTargetClick: true,
    defaultTrigger: 'hover',
    defaultDelay: {
        show: 300,
        hide: 100
    }
})
Vue.use(LZString)
Vue.use(AmplifyPlugin, AmplifyModules, Auth);
Vue.use(VModal, {
    dialog: true,
    dynamic: true,
    injectModalsContainer: true
})

Vue.use(VueSpinners)
Vue.config.productionTip = false;
new Vue({
    store,
    router,
    apolloProvider,
    render: h => h(App),
    created() {
        if (sessionStorage.redirect) {
            const redirect = sessionStorage.redirect
            delete sessionStorage.redirect
            this.$router.push(redirect)
        }
    }
}).$mount("#app");

store.commit('change', {
    graphQLurl: aws_exports.aws_appsync_graphqlEndpoint
});
window.addEventListener("offline", function(e) {
    console.warn('Browser is offline');
    store.commit('change', {
        onLine: false
    });
});
window.addEventListener("online", function(e) {
    console.warn('Browser is online!');
    store.commit('change', {
        onLine: true
    });
});
